import React, { useState, useMemo } from "react";
import { Box, Pagination, Container } from "@mui/material";
import FilterTimeline from "./FilterTimeline";
import { useQuery } from "react-query";
import { QK } from "../../base/qk";
import VisitTmelineTable from "./VisitTmelineTable";
import { getVisitTimeline } from "../../api/services/visitplan";

const VisitTimelineScreen = () => {
  const today = new Date().toISOString().split("T")[0];

  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    client: "",
    career: "",
    location: "",
    area: "",
    startDate: today,
    endDate: today,
    status: "",
    date: "",
  });

  const filtersKey = useMemo(() => JSON.stringify(filters), [filters]);

  const { data: scheduleTimeline, isLoading } = useQuery(
    [QK.scheduleTimeline, currentPage, filtersKey],
    () =>
      getVisitTimeline(
        currentPage,
        filters.client,
        filters.career,
        filters.location,
        filters.area,
        filters.startDate,
        filters.endDate,
        filters.status,
        filters.date
      ),
    {
      keepPreviousData: true,
      enabled: !!currentPage,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: 30000,
      cacheTime: 300000,
    }
  );

  const totalRecords = scheduleTimeline?.count || 0;
  const totalPages = Math.ceil(totalRecords / 30);

  const handlePageChange = (event, page) => setCurrentPage(page);

  return (
    <Container maxWidth={false} sx={{ py: 0, px: 2, pb: 2 }}>
      <FilterTimeline
        setFilters={setFilters}
        totalRecords={totalRecords}
      />
      <VisitTmelineTable
        scheduleTimeline={scheduleTimeline}
        isLoading={isLoading}
      />
      <Box display="flex" justifyContent="center" mt={3}>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
          shape="rounded"
        />
      </Box>
    </Container>
  );
};

export default VisitTimelineScreen;